import PropTypes from 'prop-types';
const PictureTypes = PropTypes.exact({
  src: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number
});
export default PictureTypes;